



























import { handleError } from "@/lib/utility/handleError";
import { MrfiktivFleetViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { DamageFleetModule } from "@/store/modules/fleet/damage-fleet.store";
import { InvoiceFleetModule } from "@/store/modules/fleet/invoice-fleet.store";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { VehicleFleetModule } from "@/store/modules/fleet/vehicle-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class TheParentFleetSelectorList extends Vue {
  isLoading = false;

  get permissionFleets(): MrfiktivFleetViewModelGen[] {
    return FleetManagerModule.permissionFleets.filter(f => f.partnerId === this.partnerId);
  }

  get partnerId() {
    return PartnerModule.partner._id;
  }

  get fleetPartnerPermission() {
    if (ReportModule.partner.id) {
      return UserModule.fleetPermission.filter(p => ReportModule.partner.id === p.partnerId);
    }

    return UserModule.fleetPermission;
  }

  get selectedFleet(): MrfiktivFleetViewModelGen | null {
    return FleetManagerModule.selectedFleet;
  }

  /**
   * Distinct list of fleetId found in fleet permission for current partner.
   */
  get distinctPartnerFleetIds() {
    return [...new Set(this.fleetPartnerPermission.map(p => p.fleetId))];
  }

  get fleetIds() {
    return this.distinctPartnerFleetIds;
  }

  async mounted() {
    if (this.partnerId && this.fleetIds.length > 0) {
      this.isLoading = true;
      await FleetManagerModule.loadParentFleets({
        partnerId: this.partnerId,
        fleetIds: this.fleetIds
      }).finally(() => (this.isLoading = false));
    }

    if (!this.selectedFleet) {
      const defaultFleet = this.permissionFleets[0];
      await FleetManagerModule.setSelectedFleetId({
        fleetId: defaultFleet.id,
        partnerId: defaultFleet.partnerId
      });
    }
  }

  async onFleetChange(fleet: MrfiktivFleetViewModelGen) {
    if (!fleet?.id || !fleet.partnerId) return;

    this.isLoading = true;
    try {
      await FleetManagerModule.getFleetTree({
        fleetId: fleet.id,
        partnerId: fleet.partnerId
      });

      this.$emit("fleetChanged", fleet);

      VehicleFleetModule.reset();
      DamageFleetModule.reset();
      InvoiceFleetModule.reset();

      await this.$router.push({ name: "FleetAnalyticsView" });
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }
}
